<h5 class="small-caps"
    i18n>{{ header() }}</h5>
<div class="border-bottom"></div>
@if (groups()) {
  <div class="list-group list-group-flush pb-3">
    @for (group of groups(); track group) {
      <a [routerLink]="[routePrefix(), group.groupId]"
         class="list-group-item list-group-item-action py-0 d-flex align-items-center border-bottom">
        <span>{{ group.name }}</span>
      </a>
    }
  </div>
}